import type { RedirectRequest } from '@azure/msal-browser';

/** Scopes for sign-in and Microsoft Graph profile (display name, etc.). */
export const GRAPH_LOGIN_SCOPES = ['User.Read'] as const;

export const loginRequest: RedirectRequest = {
  scopes: [...GRAPH_LOGIN_SCOPES],
};

function parseScopeList(raw: string | undefined): string[] {
  if (!raw?.trim()) {
    return [];
  }
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

/**
 * Scopes for your backend / OData API (e.g. `api://<app-id>/access_as_user`).
 * When empty, token acquisition falls back to {@link GRAPH_LOGIN_SCOPES} so a JWT
 * access token is still issued for signed-in users (suitable when the API accepts it).
 */
export function getApiScopes(): string[] {
  return parseScopeList(process.env.REACT_APP_AZURE_API_SCOPES);
}

/** Scopes used for `acquireTokenSilent` — API scopes when set, otherwise login scopes. */
export function getTokenRequestScopes(): string[] {
  const api = getApiScopes();
  return api.length > 0 ? api : [...GRAPH_LOGIN_SCOPES];
}
